module.exports = __webpack_public_path__ + "teqbahn-assets/media/16.f4718051.png";